"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isUrl = exports.isNumeric = exports.isMobilePhone = exports.isEmail = exports.validateString = exports.validateNumber = exports.validateBoolean = exports.isInt = exports.isVin = void 0;
const change_case_1 = require("change-case");
const isEmail_1 = __importDefault(require("validator/lib/isEmail"));
exports.isEmail = isEmail_1.default;
const isInt_1 = __importDefault(require("validator/lib/isInt"));
const isMobilePhone_1 = __importDefault(require("validator/lib/isMobilePhone"));
exports.isMobilePhone = isMobilePhone_1.default;
const isNumeric_1 = __importDefault(require("validator/lib/isNumeric"));
exports.isNumeric = isNumeric_1.default;
const isURL_1 = __importDefault(require("validator/lib/isURL"));
exports.isUrl = isURL_1.default;
const ValidationError_1 = require("./ValidationError");
function isVin(value) {
    const regex = /^[A-HJ-NPR-Z0-9]{8}[0-9X][A-HJ-NPR-Z0-9]{8}$/;
    const transliterals = {
        "A": 1, "B": 2, "C": 3, "D": 4, "E": 5, "F": 6, "G": 7, "H": 8,
        "J": 1, "K": 2, "L": 3, "M": 4, "N": 5, "P": 7, "R": 9, "S": 2,
        "T": 3, "U": 4, "V": 5, "W": 6, "X": 7, "Y": 8, "Z": 9
    };
    if (value.length !== 17 || !regex.test(value)) {
        return false;
    }
    const _value = value.toUpperCase();
    const valueChars = value.split("");
    const weights = [8, 7, 6, 5, 4, 3, 2, 10, 0, 9, 8, 7, 6, 5, 4, 3, 2];
    const transliteratedValue = valueChars.map((digit, index) => {
        if (transliterals[digit]) {
            digit = transliterals[digit];
        }
        return parseInt(digit, 10) * weights[index];
    });
    const weightedSum = transliteratedValue.reduce((acc, val) => (acc + val));
    const remainder = weightedSum % 11;
    if ((_value.charAt(8) === "X" && remainder === 10) ||
        remainder === parseInt(_value.charAt(8), 10)) {
        return true;
    }
    return false;
}
exports.isVin = isVin;
function isInt(value, options) {
    const _value = typeof value === "number" ? value.toString() : value;
    return isInt_1.default(_value, options);
}
exports.isInt = isInt;
function validateBoolean(nameForCode, value, options) {
    var _a, _b;
    const friendlyName = (_a = options.friendlyName) !== null && _a !== void 0 ? _a : change_case_1.sentenceCase(nameForCode);
    const throwError = (_b = options.throwError) !== null && _b !== void 0 ? _b : true;
    let isValid = false;
    let errorMessage;
    if (typeof value !== "boolean" &&
        typeof value !== "number" &&
        typeof value !== "string" &&
        value !== null &&
        value !== undefined) {
        errorMessage = `${friendlyName} is of an invalid type.`;
    }
    else if (options.required &&
        (value === null ||
            value === undefined ||
            (typeof value === "string" && value.length === 0))) {
        errorMessage = `${friendlyName} is required.`;
    }
    else if (typeof value === "boolean") {
        isValid = true;
    }
    else if (typeof value === "number") {
        isValid = isInt(value, { min: 0, max: 1 });
        if (!isValid)
            errorMessage = `${friendlyName} is invalid.`;
    }
    else if (typeof value === "string") {
        if (value.length === 0) {
            errorMessage = "Is Ambassador is required.";
        }
        else {
            isValid = ["0", "1", "true", "false"].includes(value);
            if (!isValid)
                errorMessage = `${friendlyName} is invalid.`;
        }
    }
    else {
        isValid = true;
    }
    if (!isValid && throwError) {
        throw new ValidationError_1.ValidationError(nameForCode, errorMessage);
    }
    return Object.assign({ isValid, nameForCode }, (errorMessage ? { errorMessage } : {}));
}
exports.validateBoolean = validateBoolean;
function validateNumber(nameForCode, value, options) {
    var _a, _b;
    const friendlyName = (_a = options.friendlyName) !== null && _a !== void 0 ? _a : change_case_1.sentenceCase(nameForCode);
    const throwError = (_b = options.throwError) !== null && _b !== void 0 ? _b : true;
    let isValid = false;
    let errorMessage;
    if (typeof value !== "number" &&
        typeof value !== "string" &&
        value !== null &&
        value !== undefined) {
        errorMessage = `${friendlyName} is of an invalid type.`;
    }
    else if (options.required &&
        (value === null ||
            value === undefined ||
            (typeof value === "string" && value.length === 0))) {
        errorMessage = `${friendlyName} is required.`;
    }
    else if (typeof value === "number" || typeof value === "string") {
        isValid = isInt(value, Object.assign(Object.assign(Object.assign({}, (typeof options.min === "number" ? { min: options.min } : {})), (typeof options.max === "number" ? { max: options.max } : {})), (typeof options.allowLeadingZeroes === "number" ?
            { allow_leading_zeroes: options.allowLeadingZeroes } :
            {})));
        if (!isValid)
            errorMessage = `${friendlyName} is invalid.`;
    }
    if (!isValid && throwError) {
        throw new ValidationError_1.ValidationError(nameForCode, errorMessage);
    }
    return Object.assign({ isValid, nameForCode }, (errorMessage ? { errorMessage } : {}));
}
exports.validateNumber = validateNumber;
function validateString(nameForCode, value, options) {
    var _a, _b;
    const friendlyName = (_a = options.friendlyName) !== null && _a !== void 0 ? _a : change_case_1.sentenceCase(nameForCode);
    const throwError = (_b = options.throwError) !== null && _b !== void 0 ? _b : true;
    let isValid = false;
    let errorMessage;
    if (typeof value !== "string" && value !== null && value !== undefined) {
        errorMessage = `${friendlyName} is of an invalid type.`;
    }
    else if (options.required &&
        (value === null ||
            value === undefined ||
            value.trim().length === 0)) {
        errorMessage = `${friendlyName} is required.`;
    }
    else if (typeof value === "string") {
        if (typeof options.minLength === "number" &&
            typeof options.maxLength === "number" &&
            (value.length < options.minLength ||
                value.length > options.maxLength)) {
            errorMessage = `${friendlyName} has to be between` +
                `${options.minLength} and ${options.maxLength} characters.`;
        }
        else if (typeof options.minLength === "number" && value.length < options.minLength) {
            errorMessage = `${friendlyName} has to be ` +
                `${options.maxLength} characters or more.`;
        }
        else if (typeof options.maxLength === "number" && value.length > options.maxLength) {
            errorMessage = `${friendlyName} has to be ` +
                `${options.maxLength} characters or less.`;
        }
        else if (options.pattern && !value.match(options.pattern)) {
            errorMessage = `${friendlyName} is invalid.`;
        }
        else {
            isValid = true;
        }
    }
    if (!isValid && throwError) {
        throw new ValidationError_1.ValidationError(nameForCode, errorMessage);
    }
    return Object.assign({ isValid, nameForCode }, (errorMessage ? { errorMessage } : {}));
}
exports.validateString = validateString;
//# sourceMappingURL=validators.js.map